import { render, staticRenderFns } from "./date-panel-label.vue?vue&type=template&id=1226e180&"
import script from "./date-panel-label.vue?vue&type=script&lang=js&"
export * from "./date-panel-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1226e180')) {
      api.createRecord('1226e180', component.options)
    } else {
      api.reload('1226e180', component.options)
    }
    module.hot.accept("./date-panel-label.vue?vue&type=template&id=1226e180&", function () {
      api.rerender('1226e180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/date-picker/panel/Date/date-panel-label.vue"
export default component.exports